import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/merge';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { IssueType1Model, IssueType2Model, IssueWebModel, SiteModel, TenantsModel } from '../../../models';
import { IssueType1Service, IssueType2Service, IssueType3Service, IssueWebService, TenantService } from '../../../services/';
import { SettingsService } from '../../../services/settings.service';
import { SiteService } from '../../../services/site.service';

@Component({
    selector: 'app-issue-create',
    templateUrl: './issue-create.component.html',
    styleUrls: ['../../layout/layout.component.scss', '../../layout/mobile.css'],
    animations: [
        trigger('slideIn', [
            state('*', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            state('void', style({ 'overflow-y': 'hidden', 'overflow-x': 'hidden' })),
            transition('* => void', [
                style({ height: '*' }),
                animate(300, style({ height: 0 }))
            ]),
            transition('void => *', [
                style({ height: '0' }),
                animate(300, style({ height: '*' }))
            ])
        ])
    ]
})
export class MobileIssueCreateComponent implements OnInit {
    IssueType2: string = "Issue Type 2";
    IssueType1: string = "Issue Type 1";
    IssueType3: string = "Issue Type 3";
    showSpinner: boolean;
    isSending: boolean = false;
    isAdminOrUserEditor: boolean;
    currentUser: any;
    photoSrc: string | ArrayBuffer;
    sites: SiteModel[] = [];
    issueType1List: IssueType1Model[] = [];
    issueType2List: IssueType2Model[] = [];
    issueType3List: any[] = [];

    tenants: TenantsModel[] = [];
    model: IssueWebModel = new IssueWebModel();
    constructor(private siteService: SiteService,
        private tenantService: TenantService,
        public router: Router,
        private route: ActivatedRoute,
        private issueType1Service: IssueType1Service,
        private issueType2Service: IssueType2Service,
        private issueType3Service: IssueType3Service,
        private settingService: SettingsService,
        private issueWebService: IssueWebService) { }

    ngOnInit() {
        this.model.SiteId = +localStorage.getItem('currentSiteId');

        this.setDefaults();
        this.loadSites(this.currentUser.accountId);
        this.loadTenant();
        this.loadIssueType1();
        this.loadIssueType2();
        this.loadIssueType3();
        this.loadSettings();
    }

    navigateToLanding() {
        this.router.navigate([`mobile`]);
    }

    loadSettings() {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        this.settingService.getValue("IssueType1", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.IssueType1 = response.Data.Value;
                }
            });

        this.settingService.getValue("IssueType2", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.IssueType2 = response.Data.Value;
                }
            });

        this.settingService.getValue("IssueType3", currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                }, 1000);
            })
            .subscribe((response: any) => {
                if (response.Data != null) {
                    this.IssueType3 = response.Data.Value;
                }
            });

    }

    saveChanges() {
        //console.log(this.model);
        this.isSending = true;
        this.model.AccountId = this.currentUser.accountId;

        this.model.IssueType3 = this.issueType3List;

        this.issueWebService.saveIssue(this.model, true)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                this.router.navigate([`/issues`], { relativeTo: this.route });
                this.isSending = false;
            });

    }

    public fileChange(fileInput: any) {
        let self = this;
        let file = <File>fileInput.target.files[0];
        if (file.size > 2000000) {
            // this.toastr.error(`Photo upload limits 2MB of file, this file is ${ (file.size / 1024 / 1024).toFixed(2) } KB. Please choose another one.`, "Error");
            return false;
        }
        var reader = new FileReader();
        reader.onload = function() {
            self.model.Image = reader.result;
            //image.photoString = reader.result.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");
            self.photoSrc = reader.result;
        };
        reader.onerror = function(error) {
            console.log('Error: ', error);
        };

        reader.readAsDataURL(file);
    }

    getSite() {
        if (this.sites != undefined && this.sites.length > 0) {

            return this.sites.filter(x => x.Id == this.model.SiteId)[0].Name;
        }

    }

    public setDefaults() {
        let now = new Date();
        this.photoSrc = "/assets/images/upload-empty.png";
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
        if (this.currentUser.role === 'admin') {
            this.isAdminOrUserEditor = true;
        }
        else if (this.currentUser.role === 'user') {
            this.isAdminOrUserEditor = false;
        }
    }

    loadSites(accountId: number) {

        this.siteService.getSitesByAccountList(accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {

                }, 1000);
            })
            .subscribe((response: any) => {
                this.sites = response.Data;

                if (localStorage.getItem('currentSiteId') != null) {
                    this.model.SiteId = +localStorage.getItem('currentSiteId');
                    this.model.IssueType1Id = 0;
                    this.model.IssueType2Id = 0;
                    //alert(this.SiteId);
                }
                //  this.toastr.success(response.Message, "Success"); 
            });
    }

    loadTenant() {
        // 
        //this.loadingTenant = true;
        this.model.TenantId = 0;
        this.tenants = [];
        this.tenantService.getTenantBySiteId(this.model.SiteId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.loadingTenant = false;
                this.tenants = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });

    }

    loadIssueType1() {
        this.issueType1Service.GetAll(this.currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.loadingTenant = false;
                this.issueType1List = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });

    }

    loadIssueType2() {
        this.issueType2Service.GetAll(this.currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {
                //this.loadingTenant = false;
                this.issueType2List = response.Data;
                // this.toastr.success(response.Message, "Success"); 
            });

    }


    loadIssueType3() {
        this.issueType3Service.GetAll(this.currentUser.accountId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    //this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: any) => {

                response.Data.forEach(element => {
                    this.issueType3List.push({
                        IssueType3Id: element.Id,
                        Value: element.Value,
                        Name: element.Name
                    });
                });

                //this.issueType3List = response.Data;

            });

    }

}



// WEBPACK FOOTER //
// ./src/app/components/mobile/issue/issue-create.component.ts